import { useTranslation } from "react-i18next";
import { langues } from "../Utils/Listings";
import MultiSelector from "./MultiSelector";

const EditLangues = (props) => {
    const { i18n } = useTranslation('common');
    return (
        <MultiSelector {...props} valuesListing={langues} label={i18n.language === "fr" ? "Langues" : "Languages"} />
    );
}

export default EditLangues;